import { create } from 'zustand';

interface Store {
  /**
   * Keeps up with the number of translations loaded
   */
  loadCount: number;

  /**
   * Informs the system that a new translation has been loaded
   */
  setLoaded: () => void;
}

/**
 * Internal store used to force a re-render locale change
 */
export const useStore = create<Store>(set => ({
  loadCount: 0,
  setLoaded: () => set(state => ({ loadCount: state.loadCount + 1 }))
}));
